import { useLocation, Link } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { useMFAStatus } from "@/hooks/useMFAStatus";
import { Text } from "@/components/ui/typography";

const HIDE_ON = ["/", "/signup", "/account/security"];

/**
 * Persistent, non-dismissible banner that nags every authenticated user
 * to enroll in two-factor authentication. Visibility is driven by
 * `organization_members.mfa_enrolled` (DB contract — see
 * .hibane/contracts/mfa-banner.md).
 */
export function MFAEnrollmentBanner() {
  const location = useLocation();
  const { data } = useMFAStatus();
  if (!data?.authenticated || !data.needsEnrollment) return null;
  // Only nag inside the authenticated account area. Public marketing pages
  // (/, /voiceagent, /about, /services, /blog, etc.) must stay clean.
  const path = location.pathname;
  if (!path.startsWith("/account")) return null;
  if (path === "/account/security") return null;

  return (
    <div className="sticky top-0 z-40 bg-[#0A3D7C] text-white border-b border-cyan-500/30">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 min-w-0">
          <ShieldAlert className="h-4 w-4 flex-shrink-0 text-cyan-300" />
          <Text size="sm" weight="medium" className="text-white truncate">
            Secure your account — set up two-factor authentication now.
          </Text>
        </div>
        <Link to="/account/security" className="flex-shrink-0 rounded-full bg-cyan-500 hover:bg-cyan-400 text-white text-sm font-semibold px-4 py-1.5 transition">
          Enable 2FA
        </Link>
      </div>
    </div>
  );
}
